module.exports = __webpack_public_path__ + "static/b3Res1-c09c950966a13c1789dd0b0f4f59bda2.png";